import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { setStore } from '@/models/store';
import { useStores } from '@/hooks/useStores';
import { getNextPath } from './storeNavigation';
import { setAllowAnotherStore } from '@/models/user';
import { Button } from '@/components/ui/Button';

const StoreConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { storeId } = useParams();
  const { stores, loading, error } = useStores();
  const nextPath = getNextPath(location.search);
  const selectedStore = stores.find((store) => store.id === storeId);

  if (loading) {
    return (
      <div className="flex min-h-[320px] items-center justify-center text-gray-500">
        Загрузка магазина...
      </div>
    );
  }

  if (error || !selectedStore) {
    return (
      <section className="mx-auto w-full max-w-xl py-8 md:py-12">
        <div className="rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <h2 className="text-xl font-semibold text-gray-900">
            {error ? 'Магазин недоступен' : 'Магазин не найден'}
          </h2>
          <p className="mt-2 text-gray-600">Вернитесь к списку и выберите магазин.</p>
          <Button
            type="button"
            className="mt-6"
            onClick={() => navigate(`/section?next=${encodeURIComponent(nextPath)}`)}
          >
            К списку магазинов
          </Button>
        </div>
      </section>
    );
  }

  const confirmStore = () => {
    setAllowAnotherStore(false);
    setStore(selectedStore);
    navigate(nextPath, { replace: true });
  };

  return (
    <section className="mx-auto flex min-h-[420px] w-full max-w-2xl items-center py-8">
      <div className="w-full rounded-xl border border-gray-200 bg-white p-6 text-center shadow-sm md:p-10">
        <h2 className="text-2xl font-semibold leading-9 text-gray-900">
          Вы хотите сменить секцию на {selectedStore.title}?
        </h2>
        <p className="mt-3 text-gray-500">
          Магазин {selectedStore.number}
          {selectedStore.city ? `, ${selectedStore.city}` : ''}
        </p>

        <div className="mt-10 flex flex-col-reverse justify-between gap-3 sm:flex-row">
          <Button
            type="button"
            variant="neutral"
            onClick={() => navigate(`/section?next=${encodeURIComponent(nextPath)}`)}
          >
            Назад
          </Button>
          <Button type="button" onClick={confirmStore}>
            Подтвердить
          </Button>
        </div>
      </div>
    </section>
  );
};

export default StoreConfirmationPage;
